import { render, staticRenderFns } from "./MemberLocationPayment.vue?vue&type=template&id=c36fb2ca"
import script from "./MemberLocationPayment.vue?vue&type=script&lang=js"
export * from "./MemberLocationPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports